import React, { useId } from 'react';
import { cn } from '@/utils/cn';
import { FieldShell, describedBy } from '@/components/UI/Field';
import { fieldClass } from '@/components/UI/fieldStyles';

export interface InputProps extends React.InputHTMLAttributes<HTMLInputElement> {
  label?: string;
  error?: string;
  hint?: string;
  /** Classes for the outer wrapper. `className` goes to the <input> itself. */
  wrapperClassName?: string;
}

const Input = React.forwardRef<HTMLInputElement, InputProps>(
  ({ className, wrapperClassName, label, error, hint, id, required, ...props }, ref) => {
    const autoId = useId();
    const inputId = id ?? autoId;

    return (
      <FieldShell id={inputId} label={label} hint={hint} error={error} required={required} className={wrapperClassName}>
        <input
          id={inputId}
          ref={ref}
          required={required}
          aria-invalid={error ? true : undefined}
          aria-describedby={describedBy(inputId, hint, error)}
          className={cn(fieldClass({ error: Boolean(error) }), className)}
          {...props}
        />
      </FieldShell>
    );
  },
);

Input.displayName = 'Input';

export { Input };
